import React from "react"

import {useDeleteClientMutation} from "../../../api/clients"

import SmallButton from "../../../toolkits/SmallButton/SmallButton"
import CustomPopup from "../../../toolkits/CustomPopup/CustomPopup"

import {SUCCESS_CODE, ERROR_CODE} from "../../../constants/other"
import {useTranslation} from "react-i18next"


const DeleteClientPopup = ({client, setUserMessage, onSubmit, close}) => {
    const { t } = useTranslation("common")

    const [deleteClient, { isLoading }] = useDeleteClientMutation()

    const handleSubmit = () => {

        deleteClient(client.id)
            .unwrap()
            .then(() => {
                onSubmit()
                close()
                setUserMessage({message: t("Client was successfully deleted!"), code: SUCCESS_CODE})
            })
            .catch(error => {
                setUserMessage({message: error.message, code: ERROR_CODE})
            })
    }

    return (
        <CustomPopup text_title={t("Do you want to delete {{client}}?", { client: client.name})} isSubtitle isAgreePopup>
            <div className="popup-bottom">
                <div className="popup-bottom-button-container">
                    <SmallButton disabled={isLoading} btnType="secondary" onClick={close}> {t("Cancel").toUpperCase()} </SmallButton>
                    <SmallButton loading={isLoading} onClick={handleSubmit}> {t("Delete").toUpperCase()} </SmallButton>
                </div>
            </div>
        </CustomPopup>
    )
}

export default DeleteClientPopup
